export enum CustomerType {
    CORPORATE = 'CORPORATE',
    COMPANY = 'COMPANY',
    COMPANY_COLLECT = 'COMPANY_COLLECT',
    COMPANY_PAYOUT = 'COMPANY_PAYOUT',
    PSP_PAYOUT = 'PSP_PAYOUT',
}